module.exports = __webpack_public_path__ + "static/media/A23_Diesel.a4ef5dc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/A23_Diesel.jpg
// module id = 1487
// module chunks = 0